import { useCallback } from 'react';
import { useRxData } from 'rxdb-hooks';

import { RxdbCollectionName } from '../rxdbCollectionName';
import type { ViewInspector, ViewInspectorCollection } from './viewInspector.types';

const useSelectedWpInspectors = (workPackageId: number) => {
  const getViewInspectorQuery = useCallback(
    (collection: ViewInspectorCollection) =>
      collection?.find({
        selector: {
          $and: [
            { workPackageId: { $eq: workPackageId } },
            { isActive: { $eq: true } },
            {
              $or: [{ fieldInspectorId: { $ne: null } }, { clerkId: { $ne: null } }],
            },
          ],
        },
      }),
    [workPackageId],
  );

  const { result: fieldInspectorsOnWorkPackage, isFetching: isViewInspectorLoading } =
    useRxData<ViewInspector>(RxdbCollectionName.VIEW_INSPECTOR, getViewInspectorQuery, {
      json: true,
    });

  return { fieldInspectorsOnWorkPackage, isViewInspectorLoading };
};

export default useSelectedWpInspectors;
